import { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  Typography,
  CircularProgress,
} from '@mui/material';
import axiosInstance from '../api/axios';

export default function DeleteUser() {
  const [email, setEmail] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleDelete = async () => {
    setOpen(false);
    setLoading(true);
    setResult(null);
    try {
      const response = await axiosInstance.delete(`/api/Users/${encodeURIComponent(email)}`);
      setResult({ ok: true, data: response.data });
    } catch (err) {
      const data = err.response?.data;
      setResult({ ok: false, data });
    } finally {
      setLoading(false);
    }
  };

  const succeeded = result?.data?.succeeded;
  const messages = result?.data?.messages;

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 6, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h5">Delete User</Typography>
      <TextField
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
      />
      <Button
        variant="contained"
        color="error"
        disabled={!email.trim() || loading}
        onClick={() => setOpen(true)}
        startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
      >
        {loading ? 'Deleting...' : 'Delete'}
      </Button>

      {result && (
        <Alert severity={succeeded ? 'success' : 'error'}>
          {messages?.length > 0
            ? messages.join(' ')
            : succeeded
            ? 'User deleted successfully.'
            : 'Failed to delete user.'}
        </Alert>
      )}

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the user <strong>{email}</strong>? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
